import API from 'services/api';

export const getBillingHistory = () => API.get('/api/profile/invoice').then(res => res?.data);
